module.exports = __webpack_public_path__ + "static/media/hired-team.bd51d52d.png";